import fileImage from "../../../../assets/images/PaymentIcons/fileImage.svg";
import PaymentyDetailsBg from "../../../../assets/images/PaymentIcons/paymentDetailsBg.svg";
import PayYouGoLogo from "../../../../assets/images/PaymentIcons/PayYouGoLogo.svg";
import ListArrow from "../../../../assets/images/PaymentIcons/ListBackArrow.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGetBillingAddressByUserIdQuery } from "../../../../store/Billing/billingApiSlice";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Input, Modal } from "../../../common";
import { ReactComponent as TrevexHalfLogo } from '../../../../assets/icons/TrevexHalfLogo.svg'
import { ReactComponent as TrevexLogo } from '../../../../assets/icons/TrevexLogo.svg'

export const ModifyAndSelectedPlan = ({ planDetails, paymentBreakdown }) => {
  const features = planDetails.Features;
  const navigate = useNavigate();
  const location = useLocation();
  const { company_id } = location.state || {};
  const [coupon, setCoupon] = useState("")
  const [shippingAd, setshippingAd] = useState([]);
  const { userInfo } = useSelector((state) => state.auth);
  const userid = userInfo?.individual?.[0]?.individualID;
  const { token } = useSelector((state) => state.auth);
  const { data, refetch } = useGetBillingAddressByUserIdQuery({id:userid, token});
  let ShippingAddress = data ? data.filter((i) => i?.is_primary == true) : [];
  const [showCouponModal, setShowCouponModal] = useState(false);

  useEffect(() => {

    if (ShippingAddress.length > 0) {
      setshippingAd(ShippingAddress);
    } else {
      if (data?.length > 0)
        setshippingAd(data)
    }

    refetch();
  }, [data, refetch]);

  const handleSum = (dataArray) => {
    let total = 0;
    dataArray?.forEach((data) => {
      total += data?.amount
    });
    return total / 100;
  }

  const handleClosePopup = () => {
    setShowCouponModal(false)
  }


  return (
    <>
      {/* <Modal className='relative' modalHandle={handleClosePopup}>
        <div className='w-[750px] text-secondarytwo'>
          <TrevexLogo />
          <TrevexHalfLogo className='absolute right-[-3px] top-[2.25rem]' />
          <div className='w-[483px] flex flex-col items-left text-left gap-4 w-[24rem] py-4'>
            <p className='text-[43px] font-semibold leading-[49.2px]'>GOT A PROMO CODE? REDEEM IT NOW!</p>
            <div>
              <div className='flex gap-2 items-center text-[15px] font-normal'>
                <p>Enter your promo code below to access our exclusive features. Whether you're exploring new opportunities or seeking insights, we've got you covered.</p>
              </div>
            </div>
            <div className="flex ">
              <Input />
              <Button
                onClick={() => {
                  sessionStorage.setItem('popup_shown', JSON.stringify(true));
                  handleClosePopup();
                  navigate('/sign-up')
                }}
                classes="bg-primary px-4 py-2 text-white text-base rounded-0 w-full">USE CODE</Button>
            </div>
          </div>
        </div>
      </Modal> */}
      <div className="pb-6 w-[385px]">
        {planDetails.slug !== 'verify_company' &&
          <div
            className="rounded-md p-4 mb-4"
            style={{
              backgroundImage: `url(${PaymentyDetailsBg})`,
              backgroundSize: `cover`,
            }}
          >
            <div className="py-4">
              <img src={fileImage} alt="" className="mx-auto" />
              <h3 className="py-4 text-center text-white font-sans">
                Upgrade Now and Start Maximizing Your Savings Today!
              </h3>

              <div className="text-center my-4">
                <button
                  className="text-[#EBF0F3] py-2 px-4 rounded-md border border-[rgba(255, 255, 255, 0.20)]"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/plans", { state: company_id });
                  }}
                >
                  Modify Selected Plan
                </button>
              </div>
            </div>
          </div>}
        {/* <div className="bg-white p-8 rounded-md mb-4">
          <h3 className="font-semibold pb-4 text-f18">Order summary</h3>
          <hr />
          <h4 className="font-semibold py-4">Price Details</h4>

          <div>
            <div className="flex justify-between mb-2">
              <p className="align-left text-f14">Plan Price</p>
              <p className="align-left text-f14">${paymentBreakdown?.extra_details?.subtotal_excluding_tax / 100}</p>
            </div>
            {coupon && <div className="flex justify-between mb-2">
              <p className="align-left text-f14">Coupon Discount <span className="font-semibold">(NY50)</span></p>
              <p className="align-left text-f14 text-[#269758]">-${97}</p>
            </div>}
            <div className="flex justify-between mb-2">
              <p className="align-left text-f14">Taxes</p>
              <p className="align-left text-f14">${paymentBreakdown?.extra_details?.tax / 100}</p>
            </div>
          </div>
          <hr />
          <div className="flex justify-between py-2">
            <p className="font-semibold align-left text-f16">Total</p>
            <p className="font-semibold align-left text-f16">${paymentBreakdown?.extra_details?.total / 100}</p>
          </div>
          <p className="text-left text-link font-semibold text-f12">GOT A PROMO CODE? CLICK HERE!</p>
          <p className="text-f10 text-[#3C4848] text-left py-2">
            Important Notice: The discounted rate applies only to the first month. Standard subscription fees will commence from the second month.
          </p>
          <Button
            // onClick={goToSearch}
            classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 flex justify-center"
          >
            Pay
          </Button>
        </div> */}
        <div className="bg-[#FFFBF2] p-8 rounded-md">
          <h3 className="font-semibold pb-2 text-f18">Selected Plan</h3>
          <div
            className="bg-white p-4 flex gap-2"
            style={{ boxShadow: `0px 4px 20px 1px rgba(255, 145, 122, 0.20)`, alignItems: "center" }}
          >
            <div>
              <img src={PayYouGoLogo} alt="PayYouGoLogo" />
            </div>

            <div>
              {planDetails?.title && <p className="text-secondary">
                <input
                  type="text"
                  value={planDetails.mode === 'subscription' ? planDetails?.title + " " + "Subscription" : planDetails?.title}
                  className="pointer-events-none"
                  InputProps={{ readOnly: true }}
                />
              </p>}
              {paymentBreakdown &&
                <>
                  <h4 className="font-semibold text-f16">
                    ${paymentBreakdown?.extra_details?.subtotal_excluding_tax / 100}/ profile
                    {/* {paymentBreakdown?.extra_details?.total_discount_amounts?.length > 0 && `- $ ${handleSum(paymentBreakdown?.extra_details?.total_discount_amounts)} ( Discount)`} {shippingAd && shippingAd[0]?.billing_add_ID && shippingAd[0]?.country === "AE" && <span> +  $ {paymentBreakdown?.extra_details?.tax / 100} (5% VAT)</span>} */}
                  </h4>
                  {/* {shippingAd && shippingAd[0]?.billing_add_ID && shippingAd[0]?.country === "AE" && <h6 className="font-semibold text-f18">Total: <span>$ {paymentBreakdown?.extra_details?.total / 100}</span> </h6>} */}

                </>
              }
            </div>
          </div>

          <h3 className="py-4 font-semibold text-f20">Benefits</h3>

          <ul>
            {features.map((feature, index) => (
              <li key={index} className="py-2 flex align-top gap-2">
                <img src={ListArrow} className="mb-auto" alt="Listarrow" />
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
